import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const IkeNowUrl = () => {
    const location = useLocation();

    const isIkeNow = useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const ikeNow = searchParams.get('ike-now');
        return ikeNow === '1';
    }, [location.search]);

    return isIkeNow;
};